import React from 'react'
import { getUserId, getIsAdmin } from 'models/user/selectors'
import { OptimizelyProvider } from '@optimizely/react-sdk'
import optimizely from 'utils/optimizely'
import { bool, number } from 'prop-types'
import { connect } from 'react-redux'

const OptimizelyProviderContainer = ({ userId, isAdmin, ...otherProps }) => (
    <OptimizelyProvider
        timeout={500}
        user={{ id: String(userId), attributes: { userId: String(userId), isAdmin } }}
        optimizely={optimizely}
    >
        {otherProps.children}
    </OptimizelyProvider>
)

OptimizelyProviderContainer.propTypes = {
    userId: number.isRequired,
    isAdmin: bool.isRequired,
}

const mapStateToProps = (state) => ({
    userId: getUserId(state),
    isAdmin: getIsAdmin(state),
})

export default connect(mapStateToProps)(OptimizelyProviderContainer)
